import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { appUrls } from "../../utils/use-get-page-url";

export const ThemeStructureGuard: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  const [searchParams] = useSearchParams();
  const themeStructureId = searchParams.get("themeStructureId");

  if (!themeStructureId) {
    return <Navigate to={appUrls.home} />;
  }

  return <>{props.children}</>;
};
